import React from 'react';
/**
 * Icon components are React elements that have a function type with an `__iconComponentType` property.
 *
 * ✅ Icon components
 * isIconComponent(<Heart />); // true
 * isIconComponent(<ArrowDown />); // true
 * isIconComponent(createElement(HeartIcon)); // true
 *
 * ❌ Not icon components
 * isIconComponent(null); // false
 * isIconComponent('Heart'); // false
 * isIconComponent(<div />); // false
 * isIconComponent(<Button />); // false
 * isIconComponent(<Carousel />); // false
 */
export function isIconComponent(element) {
    if (!React.isValidElement(element)) {
        return false;
    }
    return typeof element.type === 'object' && '__iconComponentType' in element.type;
}
//# sourceMappingURL=is-icon-component.js.map